import { gql } from '@apollo/client';
import type {
  PublicTopicPath_TopicFragment,
  TopicPath_TopicFragment,
} from '../../graphql/generated/graphqlTypes';
import entityPath from './entityPath';

type TopicTab = 'subtopics';

const TOPIC_PATH_TOPIC_FRAGMENT = gql`
  fragment topicPath_topic on PublicTopicFields {
    id
    name
  }
`;

const topicPath = (topic: TopicPath_TopicFragment, tab?: TopicTab) => {
  const base = `/topics/${entityPath(topic.name, topic.id)}`;
  return tab ? `${base}/${tab}` : base;
};

topicPath.fragments = {
  topic: TOPIC_PATH_TOPIC_FRAGMENT,
};

const PUBLIC_TOPIC_PATH_TOPIC = gql`
  fragment publicTopicPath_topic on PublicTopicFields {
    ...topicPath_topic
  }
  ${TOPIC_PATH_TOPIC_FRAGMENT}
`;

export const publicTopicPath = (topic: PublicTopicPath_TopicFragment) =>
  `/public${topicPath(topic)}`;

publicTopicPath.fragments = {
  topic: PUBLIC_TOPIC_PATH_TOPIC,
};

export default topicPath;
